var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCostume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7767 4.53671L18.6667 2.83337C18.6667 4.07105 18.175 5.25804 17.2998 6.13321C16.4246 7.00838 15.2377 7.50004 14 7.50004C12.7623 7.50004 11.5753 7.00838 10.7002 6.13321C9.82498 5.25804 9.33332 4.07105 9.33332 2.83337L4.22332 4.53671C3.69527 4.71263 3.24749 5.07153 2.96082 5.54861C2.67414 6.02569 2.56744 6.58953 2.65999 7.13837L3.33665 11.1867C3.38107 11.4608 3.52178 11.71 3.73348 11.8896C3.94519 12.0693 4.21401 12.1675 4.49165 12.1667H6.99999V23.8334C6.99999 25.1167 8.04999 26.1667 9.33332 26.1667H18.6667C19.2855 26.1667 19.879 25.9209 20.3166 25.4833C20.7542 25.0457 21 24.4522 21 23.8334V12.1667H23.5083C23.786 12.1675 24.0548 12.0693 24.2665 11.8896C24.4782 11.71 24.6189 11.4608 24.6633 11.1867L25.34 7.13837C25.4325 6.58953 25.3258 6.02569 25.0392 5.54861C24.7525 5.07153 24.3047 4.71263 23.7767 4.53671Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCostume);
export default __webpack_public_path__ + "static/media/Icon-Costume.f994edd4fa86e28400e39d6d2dc1d204.svg";
export { ForwardRef as ReactComponent };